<template>
	<div>
		<div class="breadcrumbs" id="breadcrumbs">
			<router-link class="breadcrumb-link" to="/billing/">Billing & Payments</router-link> &gt;
			<router-link class="breadcrumb-link" to="/billing/transaction-history">Team Balance Transaction History</router-link>
		</div>
		<h3>Team Balance <span>Transaction History</span></h3><div class="ws-button" @click="modals.transactionHistoryExportModal = true">Generate CSV Export</div>

		<div v-if="index.data.length">
			<table id="transaction-history" class="worksends-table">
				<thead>
				<tr>
					<th class="field-id">ID</th>
					<th class="field-date">Date</th>
					<th class="field-type">Type</th>
					<th class="field-description">Description</th>
					<th class="field-campaign">Gift Campaign & Option</th>
					<th class="field-product">Product</th>
					<th class="field-price-exvat">Price (ex. VAT)</th>
					<th class="field-price">Price (inc. VAT)</th>
					<th class="field-amount">Amount Charged</th>
					<th class="field-balance">Balance</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in index.data" :data-type="item.type" :class="rowClasses(item)">
					<td class="field-id" data-label="ID"><div class="value">#{{ item.transaction_id }}</div></td>
					<td class="field-date" data-label="Date"><div class="value"><small>{{ item.date }}</small></div></td>
					<td class="field-type" data-label="Type"><div class="value">{{ item.type}}</div></td>
					<td class="field-description" data-label="Description"><div class="value"><b>{{ item.description }}</b></div><div v-if="item.reverted_at" class="reverted-text">Reverted {{ item.reverted_at }}</div></td>
					<td class="field-campaign" data-label="Gift Campaign & Option">
						<div class="value" v-if="item.type==='fulfilment'">Order ID #{{ item.registration_id }}</div>
						<div class="value" v-else-if="item.campaign"><b><a :href="campaignUrl(item.campaign.id)">{{ item.campaign.name }}</a></b> / {{ item.option.name }}</div>
						<div class="value" v-else-if="item.product"><i>Marketplace</i></div>
					</td>
					<td class="field-product" data-label="Product"><div class="value" v-if="item.product">{{ item.product.name }}</div></td>
					<td class="field-price-exvat" data-label="Price (ex. VAT)"><div class="value" v-if="item.price_ex_vat">{{ item.price_ex_vat | toCurrency }}</div></td>
					<td class="field-price" data-label="Price (inc. VAT)"><div class="value" v-if="item.price">{{ item.price | toCurrency }}</div></td>
					<td class="field-amount" data-label="Amount Charged"><div class="value"><b>{{ positiveAmount(item.amount) | toCurrency }}</b></div></td>
					<td class="field-balance" data-label="Balance"><div class="value">{{ item.balance_live | toCurrency }}</div></td>
				</tr>
				</tbody>
			</table>

			<ws-table-meta :meta="index.meta" sum="You have % records in your transaction history."></ws-table-meta>

		</div>
		<div v-else>
			<div class="note" v-if="transactionHistoryLoaded">Your transaction history is empty.</div>
		</div>

		<transaction-history-export-modal v-if="modals.transactionHistoryExportModal" :last-transaction-id="index.data[0].transaction_id" @created="onTransactionHistoryExport" payment-method="team-balance"></transaction-history-export-modal>
	</div>
</template>

<script>
import TransactionHistoryExportModal from '@/pages/billing/TransactionHistoryExportModal';

export default {
	description: "BillingTransactionHistory",
	components: {TransactionHistoryExportModal},
	data() {
		return {
			pageParams: {
				pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 10},
				search: {val: ""},
				filters: {}
			},
			transactionHistoryLoaded: false,
		}
	},
	methods: {
		async getPage(params) {
			await this.getPageHandler({
				waitName: 'transactions.index',
				action: 'fetchTransactions', // vuex action
				pageParams: this.pageParams,
				isInit: params ? params.init : false, // parse from url query params
				pushRoute: false, // push pagination params and search q to route
				resetPagination: params ? params.resetPagination : false // new search input -> need to reset page & sorting
			});
			this.transactionHistoryLoaded = true;
		},
		async fetchData() {

		},
		campaignUrl(campaignId) {
			let campaignPart = '/campaigns/' + campaignId;
			return this.$store.state.demo.isDemo ? '/demo' + campaignPart : campaignPart;
		},
		onTransactionHistoryExport() {
			this.modals.transactionHistoryExport = false;
		},
		rowClasses(item) {
			let classes = [];
			if (item.amount === 0) classes.push('no-charge');
			if (item.reverted_at) classes.push('reverted');
			return classes.join(' ');
		},
		positiveAmount(amount) {
			if (amount > 0) return amount;
			else return 0 - amount;
		}
	},
	mounted() {
		console.log(this.$store.state.demo.isDemo);

		this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name);
		this.getPage({init:true});
		this.fetchData();
	},
	computed: {
		index () {
			return this.$store.state.transaction.index;
		},
		modals() {
			return this.$store.state.modals;
		},
	},
}
</script>

<style scoped>

</style>
